import { useEffect, useState } from "react"
import {
  SidebarProvider,
  SidebarContent,
  SidebarButton,
  FontAwesomeIcon
  // Link
} from "@nef/core"
import { Link } from "react-router-dom"
import { SidebarHoverButtonProps } from "@nef/core/lib/components/SidebarButton/components/SidebarHoverButton"

import StyledUncontrolledSidebar from "../../styles/SidebarProvider.styles"
import useAuthContext from "../../hooks/useAuthContext"
import keyToPathMap from "../../constants/authentication"
import { MenuSection, RouteElement } from "../../generated/api"
import useGetUserAndRole from "../../hooks/useGetUserAndRole"
import RecordIsMissingModal from "../../modals/common/RecordIsMissingModal"
import { NFN_LEGACY_HREF } from "../../constants/common"

import LoginFormComponent from "./LoginFormComponent"

const AppSidebar = (props: any) => {
  const { sidebar, setSidebar, hideSidebar, setHideSidebar, children } = props
  const { accessToken, handleLogOutUser } = useAuthContext()
  // const [userRole, setUserRole] = useState<string>("");
  const [sidebarVisible, setsidebarVisible] = useState<boolean>(true)
  const [sideBarMenu, setSideBarMenu] = useState<any>(null)

  useEffect(() => {
    // This is to make sure that after any refresh the sidebarmenu state is repopulated via localstore
    const routeMapString = window.localStorage.getItem("_routemap")
    if (routeMapString) {
      setSideBarMenu(JSON.parse(routeMapString))
    }
  }, [])

  const routeList = (menu: MenuSection): SidebarHoverButtonProps[] => {
    return menu?.routeElements?.map((element: RouteElement) => {
      if (!element?.menuSubSections?.length && element?.key) {
        return {
          children: (
            <Link style={{ fontSize: "12px" }} to={`/${(keyToPathMap as any)[element?.key]?.path}`}>
              {element?.title}
            </Link>
          )
        }
      }
      return {
        children: (
          <>
            {element?.menuSubSections?.map((_menu: MenuSection) => {
              if (_menu.key) {
                return (
                  <SidebarButton
                    key={_menu?.key}
                    id={_menu?.key}
                    iconClassName={(keyToPathMap as any)[_menu?.key]?.icon}
                    subButtons={[...routeList(_menu)]}
                    type="toggle"
                  >
                    {_menu.title}
                  </SidebarButton>
                )
              }
              return <></>
            })}
          </>
        )
      }
    }) as SidebarHoverButtonProps[]
  }

  return (
    <>
      <SidebarProvider expandedByDefault={sidebarVisible}>
        <StyledUncontrolledSidebar className="uncontrolled-sidebar" style={{ left: `${hideSidebar}` }}>
          {accessToken ? (
            <>
              <div className="sidebar__container">
                <div className="sidebar__top">
                  {sideBarMenu?.menuSections?.map((menu: MenuSection) => {
                    if (menu.key) {
                      return (
                        <SidebarButton
                          key={menu?.key}
                          id={menu?.key}
                          iconClassName={(keyToPathMap as any)[menu?.key]?.icon}
                          subButtons={[...routeList(menu)]}
                          type="toggle"
                        >
                          {menu.title}
                        </SidebarButton>
                      )
                    }
                    return <></>
                  })}
                </div>
                <div className={`sidebar__bottom sidebar__bottom${sidebarVisible && "--flex"}`}>
                  {!!sidebarVisible && (
                    <div className="sidebar__links">
                      <a href={NFN_LEGACY_HREF} target="_blank" rel="noreferrer" className="login-form__legacy-link">
                        Legacy NFN <FontAwesomeIcon iconClassName="fas fa-external-link-alt" />
                      </a>
                    </div>
                  )}
                  <FontAwesomeIcon
                    iconClassName={sidebarVisible ? "fa-angle-double-left" : "fa-angle-double-right"}
                    onClick={() => setsidebarVisible((v) => !v)}
                  />
                </div>
              </div>
            </>
          ) : (
            <LoginFormComponent setSideBarMenu={setSideBarMenu} />
          )}
        </StyledUncontrolledSidebar>
        <SidebarContent className="sidebar-content" baseColor={false} sidebar={sidebar}>
          {children}
        </SidebarContent>
      </SidebarProvider>
    </>
  )
}

export default AppSidebar
